import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { ConfigService } from '../../services/config.service';
import { CommonModule } from '@angular/common';
import TYPES from '../../constants/types';

@Component({
  selector: 'app-languages-selector',
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule
  ],
  templateUrl: './languages-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './languages-selector.component.scss'
})
export class LanguagesSelectorComponent {

  LANGUAGES: any;

  constructor(
    public configService: ConfigService
  ) {
    this.LANGUAGES = TYPES.LANGUAGES;
  }

  setLanguage(lang: any) {
    this.configService.setLanguage(lang.locale);
  }

}
